import { render, staticRenderFns } from "./DidaModuleHeader.vue?vue&type=template&id=18e2b090&scoped=true"
import script from "./DidaModuleHeader.vue?vue&type=script&lang=js"
export * from "./DidaModuleHeader.vue?vue&type=script&lang=js"
import style0 from "./DidaModuleHeader.vue?vue&type=style&index=0&id=18e2b090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e2b090",
  null
  
)

export default component.exports